(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rare-motion"] && !Shopify.designMode) return;
  try {
    (()=>{
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const targets=document.querySelectorAll('.introduction,.section-head,.home-grid .card,.subject-tile,.story-grid,.collector-notes,.inquiry .wrap,.index-subjects .subject-item');
 let observer;
 function reveal(){
  if(reduced.matches){targets.forEach(el=>el.classList.remove('reveal-ready'));return;}
  observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('revealed');observer.unobserve(entry.target);}}),{threshold:.08});
  targets.forEach(el=>{el.classList.add('reveal-ready');observer.observe(el);});
 }
 reveal();reduced.addEventListener('change',()=>{observer?.disconnect();reveal();});
 const header=document.querySelector('.site-header');
 let busy=false;function onScroll(){if(busy)return;busy=true;requestAnimationFrame(()=>{header.classList.toggle('is-scrolled',scrollY>24);busy=false;});}
 addEventListener('scroll',onScroll,{passive:true});onScroll();
 const menu=document.querySelector('.menu');
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu?.open){menu.open=false;menu.querySelector('summary').focus();}});
 document.addEventListener('click',e=>{if(menu?.open&&!menu.contains(e.target))menu.open=false;});
})();
  } catch(e) { console.error(e); }
})();

})();
